import { render } from "./FirmalarView.vue?vue&type=template&id=3465fac4"
import script from "./FirmalarView.vue?vue&type=script&lang=js"
export * from "./FirmalarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__